// src/index.js or src/App.js
import { ChakraProvider, ColorModeScript } from "@chakra-ui/react";
import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import theme from "./theme";

const root = createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <ChakraProvider theme={theme}>
      <ColorModeScript
        initialColorMode={theme.config.initialColorMode}
        useSystemColorMode={theme.config.useSystemColorMode}
      />
      <App />
    </ChakraProvider>
  </React.StrictMode>
);
